module.exports = {"620826001":"城区街道","620826100":"城关镇","620826101":"威戎镇","620826102":"界石铺镇","620826103":"八里镇","620826104":"李店镇","620826105":"古城镇","620826106":"仁大镇","620826107":"甘沟镇","620826108":"城川镇","620826109":"曹务镇","620826110":"雷大镇","620826111":"四河镇","620826112":"细巷镇","620826113":"双岘镇","620826114":"治平镇","620826115":"红寺镇","620826116":"原安镇","620826201":"司桥乡","620826206":"余湾乡","620826208":"贾河乡","620826209":"深沟乡","620826211":"新店乡","620826216":"三合乡","620826218":"灵芝乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620826.json
// module id = 2930
// module chunks = 0